export default __webpack_public_path__ + "static/media/risc.1b28452f.svg";